"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.showCategoryDescription = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _reflux = _interopRequireDefault(require("reflux"));

var _reactAddonsShallowCompare = _interopRequireDefault(require("react-addons-shallow-compare"));

var _UserService = _interopRequireDefault(require("./services/UserService"));

var _index = _interopRequireDefault(require("../Button/index"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _EquizzerActions = _interopRequireDefault(require("./actions/EquizzerActions"));

var _Quiz = _interopRequireDefault(require("./Quiz.scss"));

var _QuizCategories = _interopRequireDefault(require("./QuizCategories.scss"));

var _QuizStrings = require("./QuizStrings");

var _AlertHelper = require("../../../helpers/AlertHelper");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _reactSimplePieChart = _interopRequireDefault(require("react-simple-pie-chart"));

var _DataStoreComponent2 = _interopRequireDefault(require("../../../common/components/DataStoreComponent/DataStoreComponent2"));

var _QDGroupService = require("../../../KESI2/Services/QDGroupService");

var _Constants = require("../../constants/Constants");

var _ObjectHelper = require("../../../helpers/ObjectHelper");

var _ColorHelper = require("../../../helpers/ColorHelper");

var _KeyboardArrowLeft = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowLeft"));

var _QuizRoundOverviewStyle = require("./styles/QuizRoundOverviewStyle");

var _RegisterInstance = _interopRequireDefault(require("../../../KESI2/Services/RegisterInstance"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * Returns true if the description was shown, false if not
 * @param learningState
 * @param category
 * @param force
 * @param closeable
 * @param callback
 * @returns {boolean}
 */
var showCategoryDescription = function showCategoryDescription(learningState, category, force, closeable, _callback) {
  var categoryState = learningState[category.name];

  if (!categoryState) {
    return false;
  }

  if (!categoryState.description) {
    return false;
  }

  var path = "".concat(_DataStore.DATA_STORE_PATHS.QD_CATEGORY_DESCRIPTION_SEEN, ".").concat(category.name);

  var alreadySeen = categoryState.seen || _DataStore["default"].getElementByPathImmediately(path);

  if (force || !alreadySeen) {
    var button = {
      label: force ? (0, _QuizStrings.getString)('OK') : (0, _QuizStrings.getString)('START'),
      callback: function () {
        var _callback2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (_callback) {
                    _callback();
                  }

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        function callback() {
          return _callback2.apply(this, arguments);
        }

        return callback;
      }(),
      // this is for diginale
      // className: ownStyles.buttonWithBorder,
      className: _QuizCategories["default"].boldButton,
      style: {
        backgroundColor: '#0066a0',
        // TODO: needs to be taken from Theme Store
        color: '#FFFFFF'
      }
    };
    (0, _AlertHelper.showAlertWithOptions)({
      html: categoryState.description,
      title: category.name,
      showCloseButton: true,
      // || closeable,
      buttons: [button],
      size: 'large'
    }); // showWideAlertHtml(categoryState.description, category.name, closeable, [button], false)

    _DataStore["default"].setSingleData(path, true);

    return true;
  }

  return false;
};

exports.showCategoryDescription = showCategoryDescription;

var QuizCategory = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(QuizCategory, _DataStoreComponent);

  var _super = _createSuper(QuizCategory);

  function QuizCategory(props) {
    var _thisSuper, _thisSuper2, _thisSuper3, _this;

    (0, _classCallCheck2["default"])(this, QuizCategory);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "loadLearningState", /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var auth;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!_config["default"].useDrupalContent) {
                _context2.next = 7;
                break;
              }

              _context2.t0 = "Bearer ";
              _context2.next = 4;
              return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

            case 4:
              _context2.t1 = _context2.sent;
              auth = _context2.t0.concat.call(_context2.t0, _context2.t1);

              _UserService["default"].loadLearningStates(auth);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "componentWillUnmount", function () {
      (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizCategory.prototype)), "componentWillUnmount", _thisSuper).call(_thisSuper);
      clearTimeout(_this.waitingTimeout);

      if (_this.waitingDialogCloseFn) {
        _this.waitingDialogCloseFn();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "remindUser", function () {
      var okButton = {
        label: (0, _QuizStrings.getString)('OK'),
        callback: function callback() {
          _this.waitingDialogCloseFn = null;
          _this.waitingTimeout = setTimeout(function () {
            _this.remindUser();
          }, _Constants.TOURNAMENT_WARNING_TIMEOUT);
        }
      };
      _this.waitingDialogCloseFn = (0, _AlertHelper.showWideAlertHtml)((0, _QuizStrings.getString)('PLAY_NOW_TEXT_NO_USERNAME'), (0, _QuizStrings.getString)('PLAY_NOW_TITLE'), true, [okButton], true);
    });
    _this.state = {};
    _this.waitingTimeout = null;
    _this.waitingDialogCloseFn = null;
    (0, _get2["default"])((_thisSuper2 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizCategory.prototype)), "setDataStorePaths", _thisSuper2).call(_thisSuper2, [_DataStore.DATA_STORE_PATHS.QD_USER, _DataStore.DATA_STORE_PATHS.QD_GAME, _DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT, _DataStore.DATA_STORE_PATHS.QD_CATEGORIES, _DataStore.DATA_STORE_PATHS.QD_NETWORK_STATUS, _DataStore.DATA_STORE_PATHS.QD_LEARNING_STATE, _DataStore.DATA_STORE_PATHS.QD_USER_AUTH, _DataStore.DATA_STORE_PATHS.QD_GROUP_ID]);
    (0, _get2["default"])((_thisSuper3 = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(QuizCategory.prototype)), "addStoresAndKeys", _thisSuper3).call(_thisSuper3, [{
      store: _ThemeStore["default"],
      keys: ['currentTheme', 'categoryinfos', 'quiz']
    }]);
    return _this;
  }

  (0, _createClass2["default"])(QuizCategory, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.setTitle((0, _QuizStrings.getString)('CATEGORIES'));
      (0, _QDGroupService.updateQDPresence)(this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER].nickname, this.state.data[_DataStore.DATA_STORE_PATHS.QD_GROUP_ID], {}); // load asynchronously, i.e. the pie charts might change but that's not too important

      console.log('quizcategories componentDidMount', this.props);
      this.loadLearningState();

      if (this.props.tournamentMode) {
        this.waitingTimeout = setTimeout(function () {
          _this2.remindUser();
        }, _Constants.TOURNAMENT_WARNING_TIMEOUT);
      }
    }
  }, {
    key: "setCategory",
    value: function setCategory(category) {
      var _this3 = this;

      if (showCategoryDescription(this.state.data[_DataStore.DATA_STORE_PATHS.QD_LEARNING_STATE], category, false, false, function () {
        return _this3.setCategory(category);
      })) {
        return;
      }

      if (!this.props.trainingMode) {
        this.props.showSpinner(true);
        var gameData = this.state.data[_DataStore.DATA_STORE_PATHS.QD_GAME]; // get the player state (challenger or opponent)

        var _UserService$getPlaye = _UserService["default"].getPlayerState(this.state.data[_DataStore.DATA_STORE_PATHS.QD_USER], this.state.data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT], gameData),
            userData = _UserService$getPlaye.userData,
            selectedOpponentData = _UserService$getPlaye.selectedOpponentData; // update logged in player's game state


        var data = {};
        data[_DataStore.DATA_STORE_PATHS.QD_USER] = userData;
        data[_DataStore.DATA_STORE_PATHS.QD_USER_POINTS] = userData.points;
        data[_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT] = selectedOpponentData;

        _DataStore["default"].setData(data, false);

        this.props.onStartRound(gameData, category.name);
      } else {
        this.props.setTitle(category.name);
        this.props.onSetCategory(category.name);
      }
    }
  }, {
    key: "renderCategoryButton",
    value: function renderCategoryButton(category, index) {
      var _this4 = this;

      // console.log('renderCategoryButton', category)
      var learningState = this.state.data[_DataStore.DATA_STORE_PATHS.QD_LEARNING_STATE];

      var groupData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP);

      var questionsPerRound = 5;

      if (groupData && groupData.value) {
        questionsPerRound = groupData.value.questionsPerRound;
      }

      if (category.questionCount < questionsPerRound) {
        return null;
      }

      if (!learningState) {
        return null;
      }

      var categoryState = learningState[category.name];

      if (!categoryState) {
        return null;
      }

      var icon = categoryState.icon ? /*#__PURE__*/_react["default"].createElement("img", {
        className: _QuizCategories["default"].categoryIcon,
        src: categoryState.icon,
        onError: function onError(ev) {
          ev.target.height = '0px';
          ev.target.width = '0px';
        }
      }) : null;

      var hideFeedback = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_HIDE_FEEDBACK);

      var learned = hideFeedback ? 0 : categoryState.learned || 0;
      var inProgress = categoryState.inProgess || 0;
      var untouched = 1.0 - learned - inProgress;

      var learningProgressPie = /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizCategories["default"].learningProgressPie
      }, /*#__PURE__*/_react["default"].createElement(_reactSimplePieChart["default"], {
        borderWidth: 2,
        borderColor: "white",
        slices: [{
          color: this.state.categoryinfos && this.state.categoryinfos.untouched ? this.state.categoryinfos.untouched : 'transparent',
          value: untouched
        }, {
          color: this.state.categoryinfos && this.state.categoryinfos.touched ? this.state.categoryinfos.touched : 'transparent',
          value: inProgress
        }, {
          color: this.state.categoryinfos && this.state.categoryinfos.learned ? this.state.categoryinfos.learned : 'transparent',
          value: learned
        }]
      }));

      var descriptionButton = categoryState.description ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizCategories["default"].descriptionButton,
        onClick: function onClick() {
          return showCategoryDescription(_this4.state.data[_DataStore.DATA_STORE_PATHS.QD_LEARNING_STATE], category, true, true);
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "category info",
        src: require('./assets/info.svg'),
        style: {
          height: 30
        }
      })) : null;
      var questionCount = categoryState.questionCount ? /*#__PURE__*/_react["default"].createElement("span", {
        className: _QuizCategories["default"].questionCount
      }, categoryState.questionCount, " Fragen") : null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizCategories["default"].categoriesFrame
      }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
        key: "category_".concat(category.name),
        className: "".concat(_QuizCategories["default"].buttonParticipants, " ").concat(icon ? _QuizCategories["default"].withIcon : '', " button button-ergo"),
        theme: _config["default"].categoryTheme ? _config["default"].categoryTheme : null,
        onClick: function onClick() {
          return _this4.setCategory(category);
        }
      }, icon, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizCategories["default"].categoryName,
        dangerouslySetInnerHTML: {
          __html: category.name
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizCategories["default"].bottomInfo
      }, this.props.hideLearningState ? null : learningProgressPie, questionCount)), descriptionButton);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      if (!this.state.data[_DataStore.DATA_STORE_PATHS.QD_CATEGORIES] || this.state.data[_DataStore.DATA_STORE_PATHS.QD_CATEGORIES].length === 0) {
        return /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null);
      }

      var categoryButtons = this.state.data[_DataStore.DATA_STORE_PATHS.QD_CATEGORIES].map(function (category, index) {
        return _this5.renderCategoryButton(category, index);
      });

      var dynamicStyles = (0, _QuizRoundOverviewStyle.getStyles)(this.state);
      var backButton = this.props.runsInKesi ? /*#__PURE__*/_react["default"].createElement("span", {
        className: _Quiz["default"].backButton,
        style: dynamicStyles.backButtonStyle,
        onClick: this.props.onBack
      }, /*#__PURE__*/_react["default"].createElement(_KeyboardArrowLeft["default"], {
        style: {
          fontSize: '30px'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        className: _Quiz["default"].backText
      }, (0, _QuizStrings.getString)('BACK'))) : null;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _Quiz["default"].contentHome
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _Quiz["default"].innerHeader
      }, backButton), /*#__PURE__*/_react["default"].createElement("div", {
        id: "scrollElement",
        className: _Quiz["default"].innerContentScroll,
        style: {
          height: '92%'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: "innerContent",
        style: {
          height: '100%'
        }
      }, categoryButtons)));
    }
  }]);
  return QuizCategory;
}(_DataStoreComponent2["default"]);

exports["default"] = QuizCategory;
QuizCategory.propTypes = {
  onBack: _propTypes["default"].func,
  setTitle: _propTypes["default"].func.isRequired,
  onStartRound: _propTypes["default"].func.isRequired,
  showSpinner: _propTypes["default"].func.isRequired,
  tournamentMode: _propTypes["default"].bool,
  runsInKesi: _propTypes["default"].bool,
  trainingMode: _propTypes["default"].bool,
  hideLearningState: _propTypes["default"].bool
};